import React from "react";
import { Alert, Typography } from "@mui/material";

const ConflictResolutionAlert = () => (
  <Alert severity="info" sx={{ mb: 3 }}>
    <Typography variant="body2" component="div">
      <strong>Conflict Resolution</strong>
      <ul style={{ margin: "4px 0 0", paddingLeft: 20 }}>
        <li>Click on a field to select which value to keep.</li>
        <li>Top (light blue) = New OSM data. Bottom (light green) = Existing database record.</li>
        <li>Use <strong>Insert Both</strong> when the OSM bar should be added as a new record without modifying the existing bar.</li>
        <li>Red backgrounds indicate unresolved conflicts that must be addressed.</li>
        <li>If OSM and Barhopper data matches exactly, the record is excluded from conflicts.</li>
      </ul>
    </Typography>
  </Alert>
);

export default ConflictResolutionAlert;
